// StatusPage.js - /src/pages/StatusPage.js
import React from 'react';
import { Link } from 'react-router-dom';

// StatusPage.js - /src/pages/StatusPage.js
const StatusPage = () => (
  <div style={{ backgroundColor: '#0a0a0a', color: 'white', minHeight: '100vh', padding: '4rem 2rem' }}>
    <nav style={{ marginBottom: '4rem', textAlign: 'center' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
        <span style={{ fontSize: '1.5rem' }}>🕵🏽</span>
        <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#e07a5f' }}>WhyDidItDie</span>
      </Link>
    </nav>
    <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#e07a5f' }}>System Status</h1>
      <div style={{ backgroundColor: 'rgba(16,185,129,0.1)', border: '1px solid #10b981', padding: '1rem', borderRadius: '8px', marginBottom: '2rem' }}>
        <span style={{ color: '#10b981', fontSize: '1.2rem' }}>🟢 All Systems Operational</span>
      </div>
      <Link to="/homepage" style={{ color: '#e07a5f', textDecoration: 'none', fontSize: '1.1rem' }}>← Back to Home</Link>
    </div>
  </div>
);

export default StatusPage;